setPreviousQueryRef